import { render, staticRenderFns } from "./VMultiSwitcher.vue?vue&type=template&id=5ac69bc4&scoped=true&"
import script from "./VMultiSwitcher.vue?vue&type=script&lang=ts&"
export * from "./VMultiSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./VMultiSwitcher.vue?vue&type=style&index=0&id=5ac69bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac69bc4",
  null
  
)

export default component.exports